import React from 'react';

import Section from '@dashboard/components/sections/Section';
import { PlatformModelName } from '@dashboard/generated/wp/administrator';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import ModelCountRow from './ModelCountRow';

type Props = {
  platformId: string;
};

const MODEL_NAMES: PlatformModelName[] = [
  PlatformModelName.ApiKey,
  PlatformModelName.PlatformUser,
  PlatformModelName.Contact,
  PlatformModelName.ContactsGroup,
  PlatformModelName.ContactsGroupContact,
  PlatformModelName.DomainNameVerification,
  PlatformModelName.EmailMessage,
  PlatformModelName.EmailMessagesBatch,
  PlatformModelName.RequestLog,
  PlatformModelName.Template,
  PlatformModelName.TemplateImage,
  PlatformModelName.TimelineLogItem,
  PlatformModelName.VerifiedEmailAddress,
  PlatformModelName.Workflow,
  PlatformModelName.WorkflowRun,
  PlatformModelName.WorkflowRunCommand,
];

export default function ModelCounts({ platformId }: Props) {
  return (
    <Section title="Models" variant="secondary">
      <TableContainer>
        <Table size="small" sx={{ 'th,td': { border: 0 } }}>
          <TableHead>
            <TableRow>
              <TableCell width="100%">Model name</TableCell>
              <TableCell align="right">Count</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {MODEL_NAMES.map((name) => (
              <ModelCountRow key={name} platformId={platformId} name={name} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Section>
  );
}
